export const selectUsedAs = (state) => state.fabricTemplate?.usedAs;
export const selectIsTemplatePremium = (state) => state.fabricTemplate?.premium;
export const selectQuickInvite = (state) => state.fabricTemplate?.quickInvite;
